import { AssetForEdit } from 'types/interfaces';
import { generateGUID } from 'utils';

import { AssetsService } from 'components/services/AssetsService';

interface UseAssetOperationsProps {
  getAssetsApi: () => Promise<void>;
  setValue: any;
  setAssetCardKey: (key: string) => void;
}

export const useAssetOperations = ({
  getAssetsApi,
  setValue,
  setAssetCardKey
}: UseAssetOperationsProps) => {
  

  const handleAdd = async (asset: AssetForEdit) => {
    const newAsset = { ...asset };
    newAsset.parameterValues = [];
    newAsset.parameters
      .filter((x) => x.selectedValue != null && x.selectedValue !== -1)
      .forEach((x) => {
        newAsset.parameterValues.push({
          id: parseInt(x.id.toString(), 10),
          value: {
            key: (x.values[x.selectedValue!] as any).id!.toString(),
            label: x.values[x.selectedValue!].label
          }
        });
      });
    (newAsset as any).parameters = undefined;
    const response = await AssetsService.createAsset(newAsset);
    if (response.status === 201 && response.data.isSuccess) {
      const created = response.data.value;
      const createdAsset = {
        key: created.id.toString(),
        label: created.name
      };
      setValue('asset', createdAsset, {
        shouldDirty: true,
        shouldValidate: true
      });
      await getAssetsApi();
    } else {
      console.error('Ошибка при создании объекта', response);
    }
    return response.data;
  };

  const handleUpdate = async (
    id: string | number,
    updatedAsset: AssetForEdit
  ) => {
    const newAsset = { ...updatedAsset };

    newAsset.parameterValues = [];
    newAsset.parameters
      .filter((x) => x.selectedValue != null && x.selectedValue !== -1)
      .forEach((x) => {
        newAsset.parameterValues.push({
          id: parseInt(x.id.toString()),
          value: {
            key: (x.values[x.selectedValue!] as any).id!.toString(),
            label: x.values[x.selectedValue!].label
          }
        });
      });
    const assetKey = newAsset.id;
    const assetName = newAsset.name;

    if (assetKey) {
      setValue(
        'asset',
        { key: assetKey.toString(), label: assetName },
        { shouldDirty: true, shouldValidate: true }
      );
    }
    (newAsset as any).parameters = undefined;
    const result = await AssetsService.updateAsset(Number(id), newAsset);
    if (!!result.data.isSuccess) {
      await getAssetsApi();
      setAssetCardKey(generateGUID());
    }
    return result.data;
  };

  return {
    handleAdd,
    handleUpdate
  };
};
